import { useContext, useEffect, useRef, useState } from 'react';
import { socket } from '../socket';
import secureLocalStorage from 'react-secure-storage';
import { MyContext } from '../Context/MyProvider';
import ImageLoad from './ImageLoad';
import Btn_loader from './Btn_loader';
import { useNavigate } from 'react-router-dom';
import Audiocall from '../Component/pages/Audiocall';
import Videocall from '../Component/pages/Videocall';
import { useTranslation } from 'react-i18next';
const Soketcall = () => {

    const { t } = useTranslation();
    const { BaseUrl, HandleCallApi, isReqModel, setIsReqModel, modelData, setModelData, setIsToast, setToastMsg, israting, setIsRating, ratingdata, setRatingData, userlogin } = useContext(MyContext);

    const [chatTime, setChatTime] = useState("0");
    const [apiLoading, setApiLoading] = useState("");
    const [running, setRunning] = useState(false);
    const [isCallModel, setIsCallModel] = useState("");
    const [ratingStar, setRatingStar] = useState(1);
    const [rateDesc, setRateDesc] = useState("");
    const [ringtone, setRingTone] = useState("");

    const audioRef = useRef(null);
    const navigate = useNavigate();

    const [userId, setUserId] = useState(secureLocalStorage.getItem("Userid"));

    useEffect(() => {
        setUserId(secureLocalStorage.getItem("Userid"));
    }, [userlogin]);

    const handleCallError = (data) => {
        setApiLoading("");
        setIsReqModel(false);
        let errorMsg = "Calling service error";
        if (data.message === "low_wallet_balance") {
            errorMsg = "Low wallet balance to initiate call";
        } else if (data.message === "calling_service_unconfigured") {
            errorMsg = "Calling service not configured by admin";
        } else if (data.message === "credentials_expired") {
            errorMsg = "Voice/Video server credentials expired";
        } else if (data.message) {
            errorMsg = data.message;
        }
        setIsToast(true);
        setToastMsg(errorMsg);
    };

    useEffect(() => {
        if (!userId) return;
        socket.on(`accept_socket${userId}`, handleAcceptScoket);
        socket.on(`chat_time_over_user${userId}`, handleChatTimeOver);
        socket.on(`appointment_update${userId}`, handleAppointmentUpdate);
        socket.on(`call_error_user${userId}`, handleCallError);
        return () => {
            socket.off(`accept_socket${userId}`, handleAcceptScoket);
            socket.off(`chat_time_over_user${userId}`, handleChatTimeOver);
            socket.off(`appointment_update${userId}`, handleAppointmentUpdate);
            socket.off(`call_error_user${userId}`, handleCallError);
        };
    }, [userId]);

    useEffect(() => {
        if (!running) return;
        const interval = setInterval(() => {
            setChatTime((prev) => {
                const { time, finished } = updateChatTimer(prev);
                if (finished) {
                    setRunning(false);
                    setIsReqModel(false);
                }
                return time;
            });
        }, 1000);
        return () => clearInterval(interval);
    }, [running]);

    useEffect(() => {
        if (!modelData) return;
        const onAcceptUserMsg = (data) => {
            handleAccept();
        };
        const onAstroCallError = (data) => {
            handleCallError(data);
        };
        socket.on(`accept_user_message${modelData?.astrologer_id}`, onAcceptUserMsg);
        socket.on(`call_error_astrologer${modelData?.astrologer_id}`, onAstroCallError);
        return () => {
            socket.off(`accept_user_message${modelData?.astrologer_id}`, onAcceptUserMsg);
            socket.off(`call_error_astrologer${modelData?.astrologer_id}`, onAstroCallError);
        };
    }, [modelData]);

    useEffect(() => {
        let audioInterval;
        let playTimeout;
        if (ringtone && audioRef.current) {
            playTimeout = setTimeout(() => {
                if (audioRef.current) {
                    audioRef.current.play().catch(error => {
                        console.log("Ringtone play interrupted:", error);
                    });
                }
            }, 100);
            audioInterval = setInterval(() => {
                if (audioRef.current) {
                    audioRef.current.pause();
                    audioRef.current.currentTime = 0;
                }
            }, 60000);
        }
        return () => {
            clearTimeout(playTimeout);
            clearInterval(audioInterval);
        };
    }, [ringtone]);

    useEffect(() => {
        if (!isReqModel) {
            if (audioRef.current) {
                audioRef.current.pause();
                audioRef.current.currentTime = 0;
            }
            setRingTone("");
        }
    }, [isReqModel]);


    const handleAcceptScoket = (data) => {
        if (data) {
            console.log("accept_socket", data);
            secureLocalStorage.setItem("modeldata", JSON.stringify(data));
            setIsReqModel(true);
            setModelData(data);
            setApiLoading("");
            if (data.waiting_status === 1) {
                setChatTime(data.waiting_time);
                setRunning(true);
            } else {
                setChatTime("0");
                setRunning(false);
                setRingTone(data?.RingTone_Appointment);
            }
        }
    }

    const handleChatTimeOver = (data) => {
        setApiLoading("");
        setIsRating(true);
        setRatingData(data);
        if (data?.conversation_type == "1") {
            navigate("/");
        }
    }

    const handleAppointmentUpdate = (data) => {
        if (data.status == 2 || data.status == "2") {
            console.log("Appointment is in waiting status (status 2). Not navigating to chat.");
            return;
        }
        if (data.status == 5 || data.status == "5") {
            setIsReqModel(false);
            setApiLoading("");
            secureLocalStorage.removeItem("modeldata");
            setIsToast(true);
            setToastMsg(t("Consultation request declined or expired."));
            return;
        }
        if (data.appointment_type == "1") {
            const titleSlug = data.astro_name.replace(/\s+/g, "-").toLowerCase();
            setApiLoading("");
            setIsReqModel(false);
            navigate(`chat/${titleSlug}`, { state: data });
            return;
        }
        setIsCallModel(data.appointment_type === "2" ? "Audio" : data.appointment_type === "3" ? "Video" : "");
        setIsReqModel(false);
    }

    const handleAccept = () => {
        const { astrologer_id, appoint_id } = modelData;
        const payload = { astrologer_id, appoint_id };
        socket.emit("accept_user", payload);
        setApiLoading("Accept");
        audioRef.current.pause();
        audioRef.current.currentTime = 0;
    };

    const handleReject = async () => {
        setApiLoading("Reject");
        const response = await HandleCallApi("Post", "user/reject_appointment", { appoint_id: modelData?.appoint_id });
        setIsToast(true);
        setToastMsg(response.data.message);
        
        socket.emit("cancel_appointment_user", {
            astrologer_id: modelData?.astrologer_id,
            user_id: secureLocalStorage.getItem("Userid"),
            appoint_id: modelData?.appoint_id
        });

        setApiLoading("");
        setIsReqModel(false);
        secureLocalStorage.removeItem("modeldata");
        audioRef.current.pause();
        audioRef.current.currentTime = 0;
    }

    const updateChatTimer = (time) => {
        const [min, sec] = time.split(":").map(Number);
        let total = min * 60 + sec - 1;
        const minutes = String(Math.floor(Math.max(total, 0) / 60)).padStart(2, "0");
        const seconds = String(Math.max(total, 0) % 60).padStart(2, "0");
        return { time: `${minutes}:${seconds}`, finished: total <= 0 };
    };

    const handleAddRating = async () => {

        if (!rateDesc) {
            setIsToast(true);
            setToastMsg("Enter your feedback !!");
            return;
        }

        const payload = {
            appoint_id: ratingdata.appointment_id,
            total_rate: ratingStar,
            rate_desc: rateDesc,
            status: "user",
            conversation_type: ratingdata.conversation_type
        };
        setApiLoading("Rating");
        const response = await HandleCallApi("Post", "user/rating_data", payload);
        setIsToast(true);
        setToastMsg(response.data.message);
        setApiLoading("");
        setIsRating(false);
    };

    return (
        <>

            {ringtone && <audio ref={audioRef} src={BaseUrl + ringtone} loop />}

            {isReqModel && <div className="model items-center animate-fade-in">
                <div className="chatreq_box relative">

                    {modelData?.waiting_status == 1 && <button onClick={handleReject} className='absolute -top-2 -right-2 bg-[--bgcolor] p-[5px] rounded-full shadow-md hover:scale-105 duration-300'>
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M13.414 12L18.707 6.70695C19.098 6.31695 19.098 5.68301 18.707 5.29301C18.316 4.90201 17.684 4.90201 17.293 5.29301L12 10.586L6.70701 5.29301C6.31601 4.90201 5.68401 4.90201 5.29301 5.29301C4.90201 5.68301 4.90201 6.31695 5.29301 6.70695L10.586 12L5.29301 17.293C4.90201 17.683 4.90201 18.3169 5.29301 18.7069C5.48801 18.9019 5.74401 19 6.00001 19C6.25601 19 6.51201 18.9019 6.70701 18.7069L12 13.414L17.293 18.7069C17.488 18.9019 17.744 19 18 19C18.256 19 18.512 18.9019 18.707 18.7069C19.098 18.3169 19.098 17.683 18.707 17.293L13.414 12Z" fill="white" />
                        </svg>
                    </button>}

                    {modelData?.waiting_status !== 1 ? (
                        <>
                            <div className="incoming-badge">
                                <span className="pulse-dot"></span>
                                {t("Incoming Request")}
                            </div>
                            <p className='text-center text-[18px] font-semibold text-gray-800 mb-6'>
                                {t("incoming") ? t("incoming").charAt(0).toUpperCase() + t("incoming").slice(1) : "Incoming"} {modelData.appointment_type == "1" ? t("Chat") : modelData.appointment_type == "2" ? t("Audio Call") : t("Video Call")} {t("request from")}
                                <span className='text-[--bgcolor] font-bold block mt-1'> {modelData?.Astrologer_name}</span>
                            </p>
                        </>
                    ) : (
                        <p className='text-center text-[18px] font-semibold text-gray-800 mb-6'>{t("Waitlist Joined !!")}</p>
                    )}

                    <div className="flex flex-col items-center my-2">
                        <div className="flex items-center justify-center gap-[24px]">
                            {/* User Avatar Circle */}
                            <div className="w-[84px] h-[84px] relative">
                                <div className="w-full h-full border-[3px] border-white rounded-full overflow-hidden shadow-md">
                                    <ImageLoad url={modelData?.User_image ? BaseUrl + modelData?.User_image : ""} CustomeStyle={"w-full h-full object-cover"} alt={`${modelData?.User_name} image`} />
                                </div>
                            </div>
                            
                            {/* Connection Node */}
                            <div className="connection-node">
                                <div className="node-pulse"></div>
                                <div className="node-icon bg-[--bgcolor]">
                                    {modelData?.appointment_type === "1" && <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M12.001 3C7.031 3 3.00197 7.02902 3.00197 11.999C3.00197 13.339 3.30205 14.619 3.83205 15.758C4.04205 16.198 4.04211 16.708 3.89211 17.178L3.05202 19.678C2.79202 20.458 3.54204 21.208 4.32204 20.948L6.82204 20.108C7.29204 19.958 7.80196 19.958 8.24196 20.168C9.38196 20.698 10.662 20.998 12.002 20.998C16.972 20.998 21.001 16.969 21.001 11.999C21 7.02902 16.971 3 12.001 3ZM8.00197 13C7.44997 13 6.99709 12.552 6.99709 12C6.99709 11.448 7.43996 11 7.99196 11H8.00197C8.55497 11 9.00197 11.448 9.00197 12C9.00197 12.552 8.55497 13 8.00197 13ZM12.002 13C11.45 13 10.9971 12.552 10.9971 12C10.9971 11.448 11.44 11 11.992 11H12.002C12.555 11 13.002 11.448 13.002 12C13.002 12.552 12.555 13 12.002 13ZM16.002 13C15.45 13 14.9971 12.552 14.9971 12C14.9971 11.448 15.44 11 15.992 11H16.002C16.555 11 17.002 11.448 17.002 12C17.002 12.552 16.555 13 16.002 13Z" fill="white" />
                                    </svg>}
                                    {modelData?.appointment_type === "2" && <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M17.6249 14.174L20.268 15.75C20.814 16.076 21.0959 16.71 20.9709 17.334C20.4599 19.893 17.89 21.533 15.373 20.842C9.43395 19.212 4.79484 14.587 3.15884 8.635C2.46684 6.117 4.10495 3.54498 6.66495 3.03298L6.68179 3.02999C7.30679 2.90499 7.94395 3.18799 8.26895 3.73699L9.83194 6.376C10.3879 7.314 10.1118 8.52398 9.20279 9.12798L7.5419 10.233C8.7139 13.04 10.9538 15.289 13.7528 16.459L14.8678 14.794C15.4768 13.887 16.6869 13.615 17.6249 14.174ZM17.7499 9.99999C17.7499 7.93199 16.0669 6.24999 13.9999 6.24999C13.5859 6.24999 13.2499 6.58599 13.2499 6.99999C13.2499 7.41399 13.5859 7.74999 13.9999 7.74999C15.2399 7.74999 16.2499 8.75899 16.2499 9.99999C16.2499 10.414 16.5859 10.75 16.9999 10.75C17.4139 10.75 17.7499 10.414 17.7499 9.99999ZM19.9999 10.75C19.5859 10.75 19.2499 10.414 19.2499 9.99999C19.2499 7.10499 16.8949 4.74999 13.9999 4.74999C13.5859 4.74999 13.2499 4.41399 13.2499 3.99999C13.2499 3.58599 13.5859 3.24999 13.9999 3.24999C17.7219 3.24999 20.7499 6.27799 20.7499 9.99999C20.7499 10.414 20.4139 10.75 19.9999 10.75Z" fill="white" />
                                    </svg>}
                                    {modelData?.appointment_type === "3" && <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M22 7.56006V16.4399C22 17.0719 21.2689 17.4221 20.7759 17.0271L18.6121 15.29C18.5411 15.233 18.5 15.1469 18.5 15.0559V8.94409C18.5 8.85309 18.5411 8.76696 18.5 8.94409C18.5 8.85309 18.5411 8.76696 18.6121 8.70996L20.7759 6.9729C21.2689 6.5779 22 6.92806 22 7.56006ZM17 16V8C17 6 16 5 14 5H5C3 5 2 6 2 8V16C2 18 3 19 5 19H14C16 19 17 18 17 16Z" fill="white" />
                                    </svg>}
                                </div>
                            </div>

                            {/* Astrologer Avatar Circle */}
                            <div className="w-[84px] h-[84px] relative">
                                <div className="w-full h-full border-[3px] border-white rounded-full overflow-hidden shadow-md">
                                    <ImageLoad url={modelData?.Astrologer_image ? BaseUrl + modelData?.Astrologer_image : ""} CustomeStyle={"w-full h-full object-cover"} alt={`${modelData?.Astrologer_name} image`} />
                                </div>
                            </div>
                        </div>
                        
                        {/* Names Row */}
                        <div className="flex justify-between w-full max-w-[280px] mt-3 px-1">
                            <p className='text-center text-[14px] font-semibold text-gray-700 w-[110px] truncate'>{modelData?.User_name}</p>
                            <p className='text-center text-[14px] font-semibold text-gray-700 w-[110px] truncate'>{modelData?.Astrologer_name}</p>
                        </div>
                    </div>

                    {modelData?.waiting_status == 1 && <p className='text-center pt-[20px] font-medium text-[17px]'>
                        {modelData.appointment_type == "1" ? "Chat" : modelData.appointment_type == "2" ? "Voice" : "Video"} {t("will start in")}
                        <span className='text-green-500'> ~ {typeof chatTime === 'string' && chatTime.includes(":") ? chatTime : Math.round(Number(chatTime || 0))} min</span>
                    </p>}

                    <div className="chatreq-notice-box">
                        <svg className="chatreq-notice-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                            <path d="M12 16V12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                            <path d="M12 8H12.01" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                        <div className="chatreq-notice-text">
                            <span className="chatreq-notice-highlight">{t("Secure Connection:")} </span>
                            {t("You will receive a")} {modelData.appointment_type == "1" ? t("Chat") : modelData.appointment_type == "2" ? t("Audio Call") : t("Video Call")} {t("request when the astrologer is ready. Don’t worry! You will not be charged for missing this session.")}
                        </div>
                    </div>

                    {modelData?.waiting_status !== 1 && <div className="flex items-center justify-center gap-4 mt-6">
                        <button onClick={handleReject} className="chatreq-btn chatreq-btn-reject">
                            {apiLoading === "Reject"
                                ? <Btn_loader CustomeStyle={"bg-gray-500"} />
                                : t("Reject")}
                        </button>
                        <button onClick={handleAccept} className="chatreq-btn chatreq-btn-accept">
                            {apiLoading === "Accept"
                                ? <Btn_loader CustomeStyle={"bg-white"} />
                                : t("Accept")}
                        </button>
                    </div>}

                </div>
            </div>}

            {israting && <div className="model items-end">
                <div className="rating_box">
                    <div className="w-[100px] h-[100px] mx-auto">
                        <div className="w-full h-full rounded-full overflow-hidden">
                            <ImageLoad url={ratingdata?.astrologer_detail?.image ? BaseUrl + ratingdata?.astrologer_detail?.image : ""} CustomeStyle={"w-full h-full object-cover"} alt={`${ratingdata?.astrologer_detail?.name} image`} />
                        </div>
                    </div>
                    <h1 className='text-center font-medium text-[18px] mt-[10px]'>{ratingdata?.astrologer_detail?.name}</h1>

                    <div className="flex justify-center my-[10px]">
                        {[1, 2, 3, 4, 5].map((item) => {
                            const IsSelected = ratingStar >= item;
                            return <div key={item} onClick={() => setRatingStar(item)} className={`cursor-pointer text-[--bgcolor]`}>
                                {!IsSelected
                                    ? <svg width="35" height="35" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M16.8541 21.75C16.5651 21.75 16.275 21.681 16.006 21.54L12.1181 19.505C12.0441 19.466 11.956 19.466 11.882 19.505L7.997 21.538C7.378 21.862 6.6421 21.808 6.0761 21.396C5.5131 20.985 5.23508 20.304 5.35308 19.617L6.09405 15.316C6.10805 15.235 6.081 15.153 6.023 15.096L2.78203 11.95C2.30103 11.483 2.13009 10.796 2.33709 10.157C2.54409 9.51798 3.08601 9.06099 3.75201 8.96399L8.23406 8.31598C8.31606 8.30398 8.38605 8.25299 8.42205 8.17999L10.365 4.26202C10.675 3.63702 11.3011 3.24902 11.9991 3.24902C12.6971 3.24902 13.3231 3.63702 13.6331 4.26202L15.575 8.17902C15.612 8.25302 15.6821 8.30398 15.7641 8.31598L20.246 8.96399C20.912 9.05999 21.4541 9.51698 21.6611 10.157C21.8681 10.796 21.697 11.483 21.216 11.95L17.976 15.095C17.916 15.153 17.8901 15.235 17.9041 15.316L18.6451 19.619C18.7631 20.305 18.487 20.986 17.923 21.396C17.605 21.631 17.2301 21.75 16.8541 21.75ZM12.0001 17.976C12.2791 17.976 12.559 18.042 12.813 18.175L16.7011 20.21C16.8561 20.292 16.982 20.229 17.042 20.185C17.102 20.142 17.197 20.043 17.168 19.875L16.4271 15.571C16.3291 15.001 16.519 14.421 16.934 14.019L20.173 10.875C20.27 10.781 20.254 10.675 20.236 10.621C20.218 10.566 20.168 10.47 20.033 10.45L15.5511 9.802C14.9801 9.72 14.4871 9.36201 14.2321 8.84601L12.2911 4.92999C12.2141 4.77399 12.076 4.75098 12.001 4.75098C11.926 4.75098 11.7881 4.77399 11.7111 4.92999L9.7691 8.84698C9.5151 9.36198 9.0221 9.72 8.4511 9.802L3.96905 10.45C3.83405 10.47 3.78304 10.565 3.76604 10.621C3.74804 10.676 3.73303 10.781 3.82903 10.875L7.06902 14.02C7.48302 14.421 7.673 15.001 7.575 15.571L6.83404 19.872C6.80504 20.041 6.90111 20.14 6.96111 20.184C7.02311 20.228 7.14501 20.29 7.30401 20.209L11.189 18.176C11.441 18.043 11.7211 17.976 12.0001 17.976Z" fill="currentColor" />
                                    </svg>
                                    : <svg width="35" height="35" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M12.962 4.59601L14.904 8.513C15.05 8.808 15.332 9.01202 15.659 9.05902L20.1419 9.70697C20.9639 9.82597 21.292 10.834 20.697 11.412L17.456 14.557C17.219 14.787 17.111 15.118 17.167 15.443L17.9079 19.747C18.0579 20.62 17.1409 21.286 16.3549 20.875L12.467 18.84C12.175 18.687 11.827 18.687 11.536 18.84L7.65096 20.873C6.86396 21.285 5.94393 20.618 6.09493 19.743L6.83602 15.443C6.89202 15.118 6.78396 14.787 6.54696 14.557L3.30599 11.412C2.70999 10.834 3.03792 9.82597 3.86092 9.70697L8.34395 9.05902C8.66995 9.01202 8.95196 8.808 9.09896 8.513L11.041 4.59601C11.432 3.80101 12.568 3.80101 12.962 4.59601Z" fill="currentColor" />
                                    </svg>}
                            </div>
                        })}
                    </div>

                    <textarea onChange={(e) => setRateDesc(e.target.value)} className='w-full max-h-[80px] min-h-[80px] border p-[10px] border-gray-500 rounded-[10px] mt-[10px] focus-within:outline-[--bgcolor]' placeholder='Describe your experience (optional)' />
                    <p className='text-center text-[14px] text-gray-600 mt-[5px]'>{t("Great, what did you like the mast? 😍")}</p>
                    <button onClick={handleAddRating} className='w-full h-[40px] mt-[15px] bg-[--bgcolor] font-medium rounded-full text-[15px] hover:shadow-md text-white duration-[0.3s]'>
                        {apiLoading === "Rating"
                            ? <Btn_loader CustomeStyle={"bg-white"} />
                            : t("Submit")}
                    </button>
                    <button onClick={() => setIsRating(false)} className='w-full h-[40px] mt-[10px] font-medium text-[15px] border-2 rounded-full hover:shadow-md duration-[0.3s]'>{t("Skip")}</button>
                </div>
            </div>}

            {isCallModel === "Audio" && <div className="model items-center">
                <div className="Audio_box scroll_container">
                    <Audiocall CallData={modelData} setIsVoiceCall={setIsCallModel} />
                </div>
            </div>}

            {isCallModel === "Video" && <div className="model items-center">
                <div className="video_box scroll_container">
                    <Videocall CallData={modelData} setIsVideoCall={setIsCallModel} />
                </div>
            </div>}
        </>
    )
}

export default Soketcall